import jwt_decode from 'jwt-decode';

export const getInformation = (token) => {
  const accessToken = token ?? getCookie(STORAGEKEY.ACCESS_TOKEN);

  return accessToken && jwt_decode(accessToken);
};
